module.exports = __webpack_public_path__ + "img/austria-digestive-diseases-female.fc76aa9e.png";